import type { ReactNode } from 'react';
import {
  AppstoreOutlined,
  ApartmentOutlined,
  ApiOutlined,
  KeyOutlined,
  CloudServerOutlined,
  CloudUploadOutlined,
  CreditCardOutlined,
  DashboardOutlined,
  DeploymentUnitOutlined,
  FileTextOutlined,
  FlagOutlined,
  MailOutlined,
  NotificationOutlined,
  RobotOutlined,
  SafetyCertificateOutlined,
  TeamOutlined,
} from '@ant-design/icons';

export type AdminNavigationItem = {
  key: string;
  label: string;
  title: string;
  icon: ReactNode;
};

export const adminNavigationItems: AdminNavigationItem[] = [
  {
    key: '/',
    label: 'Dashboard',
    title: 'Overview',
    icon: <DashboardOutlined />,
  },
  {
    key: '/organizations',
    label: 'Organizations',
    title: 'Organizations',
    icon: <ApartmentOutlined />,
  },
  {
    key: '/projects',
    label: 'Projects',
    title: 'Projects',
    icon: <AppstoreOutlined />,
  },
  {
    key: '/access',
    label: 'Access',
    title: 'Access',
    icon: <KeyOutlined />,
  },
  {
    key: '/subscriptions',
    label: 'Subscriptions',
    title: 'Subscriptions',
    icon: <CreditCardOutlined />,
  },
  {
    key: '/invoices',
    label: 'Invoices',
    title: 'Invoices',
    icon: <FileTextOutlined />,
  },
  {
    key: '/feature-flags',
    label: 'Feature Flags',
    title: 'Feature Flags',
    icon: <FlagOutlined />,
  },
  {
    key: '/inbox',
    label: 'Inbox',
    title: 'Inbox',
    icon: <MailOutlined />,
  },
  {
    key: '/notifications',
    label: 'Notifications',
    title: 'Notifications',
    icon: <NotificationOutlined />,
  },
  {
    key: '/bundles',
    label: 'Bundles',
    title: 'Bundles',
    icon: <CloudUploadOutlined />,
  },
  {
    key: '/installs',
    label: 'Installs',
    title: 'Installs',
    icon: <DeploymentUnitOutlined />,
  },
  {
    key: '/users',
    label: 'Users',
    title: 'Users',
    icon: <TeamOutlined />,
  },
  {
    key: '/operations',
    label: 'Operations',
    title: 'Operations',
    icon: <ApiOutlined />,
  },
  {
    key: '/do',
    label: 'DO',
    title: 'Droplet Ops',
    icon: <CloudServerOutlined />,
  },
  {
    key: '/ai',
    label: 'AI',
    title: 'AI',
    icon: <RobotOutlined />,
  },
  {
    key: '/admins',
    label: 'Admins',
    title: 'Admins',
    icon: <SafetyCertificateOutlined />,
  },
];

export const resolveAdminPageTitle = (pathname: string) => {
  const normalizedPath = pathname === '/' ? pathname : pathname.replace(/\/+$/, '');
  const matched = adminNavigationItems
    .filter(item => (item.key === '/' ? normalizedPath === '/' : normalizedPath.startsWith(item.key)))
    .sort((a, b) => b.key.length - a.key.length)[0];

  return matched?.title || 'Overview';
};
